import { render, staticRenderFns } from "./FilterTerm.vue?vue&type=template&id=b3bf4d2e&scoped=true&"
import script from "./FilterTerm.vue?vue&type=script&lang=js&"
export * from "./FilterTerm.vue?vue&type=script&lang=js&"
import style0 from "./FilterTerm.vue?vue&type=style&index=0&id=b3bf4d2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bf4d2e",
  null
  
)

export default component.exports